export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    ResultPage: ['MealResultPage'],
    _Entity: ['Meal', 'SportActivity', 'User', 'Workout'],
  },
};
export default result;
